export default __webpack_public_path__ + "static/media/apple-podcast.360b241b.png";